module.exports = __webpack_public_path__ + "static/media/sparkle-small.92ad3e63.svg";